import {styled} from '@linaria/react';
import React, {FC} from 'react';
import {COLORS} from '../../../constants/colors';
import {Icon} from '../../atoms/Icon/Icon';
import {GenericIconName} from '../../atoms/Icon/IconName';

export const BreadcrumbArrowIcon: FC<{position: number}> = ({position}) => {
  if (position === 0) {
    return null;
  }

  return <StyledArrowIcon asset={GenericIconName.ArrowRight} />;
};

const StyledArrowIcon = styled(Icon)`
  &&& {
    display: inline-block;
  }
  fill: ${COLORS.Grey1};
  height: 13px;
  margin: 0 4px;
  transform: translateY(3px);
  width: 13px;
`;
